import { useEffect } from 'react';
import WOW from 'wowjs';

const useWow = () => {
  useEffect(() => {
    const wow = new WOW.WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true,
    });
    wow.init();
  }, []);
};

export default useWow; 